module.exports = __webpack_public_path__ + "img/item7.039d6b8e.png";